import React, { FC, memo, useContext } from 'react';
import ButtonTertiaryDark from '@nexus/lib-react/dist/core/Button/ButtonTertiaryDark';
import { useI18n } from '../../../../i18n';
import { TAB_TYPE_BUYING, TAB_TYPE_SELLING, TAB_TYPE_CLAIMS_AND_RETURNS } from '../../constants';
import TabsContext from '../contexts/TabsContext';

import S from './style/EmptyPanel';

const i18nKey = (key: string) => `dlv_orders_${key}`;

interface EmptyPanelProps {
  showTipEnd?: boolean;
  onClick?: VoidFunction;
  url: string;
}

// TODO: this component must be refactored to render tab-specific content. The logic for `url` and `showTipEnd` is confusing
const EmptyPanel: FC<EmptyPanelProps> = ({ onClick, url, showTipEnd }) => {
  const type = useContext(TabsContext);

  const stateKey = (key: TemplateStringsArray) => {
    switch (type) {
    case TAB_TYPE_SELLING: {
      return i18nKey(`selling_${key}`);
    }
    case TAB_TYPE_BUYING: {
      return i18nKey(`buying_${key}`);
    }
    default: {
      return i18nKey(`${type}_${key}`);
    }
    }
  };

  const i18n = useI18n();

  return (
    <S.Container data-cy="empty-panel">
      <S.WaterMark>
        <S.DeliveryIcon />
      </S.WaterMark>
      <S.Tip isActionBtn={!!onClick}>
        {`${i18n(stateKey`tip`)} `}
        {url && (
          <S.DetailsLink
            href={url}
            data-testid="details-link"
            target={type === TAB_TYPE_CLAIMS_AND_RETURNS ? '_blank' : '_self'}
            rel={type === TAB_TYPE_CLAIMS_AND_RETURNS ? 'noopener noreferrer' : null}
          >
            {i18n(stateKey`link`)}
          </S.DetailsLink>
        )}
        {showTipEnd && ` ${i18n(stateKey`tip_end`)}`}
      </S.Tip>
      {onClick && (
        <ButtonTertiaryDark marginBottom={52} onClick={onClick} data-testid="action-button">
          {i18n(stateKey`action`)}
        </ButtonTertiaryDark>
      )}
    </S.Container>
  );
};

export default memo(EmptyPanel);
